import "./GenericSkeleton.scss";

export const GenericSkeleton = () => {
  return (
    <div className="search-structure-skeleton-container">
      {/* Page title */}
      <div className="search-structure-skeleton-title pulse"></div>

      <div className="search-structure-skeleton-description-generic pulse"></div>

      <div className="search-structure-skeleton-results">
        <div className="search-structure-skeleton-map pulse"></div>
      </div>
    </div>
  );
};
